<template>
  <div>
    <a-modal
      title="查看核销详情"
      style="top: 20px;"
      :width="1000"
      v-model="visible"
      :confirmLoading="confirmLoading"
      @ok="handleSubmit1"
      @cancel="handleClose"
      :closable="false"
      :maskClosable="false"
      :destroyOnClose="true"
    >
      <a-form :form="form">
        <div style="padding: 10px" v-for="(item,index) in data" :key="index">
          <a-form-item>                                             <!--判断 没有关联关系的显示-->
            <div style="padding: 10px">
              <strong> {{item.subjectName}}</strong>
            </div>
            <div style="margin-left: 95px;padding:0 15px" class="test">
            <span v-for="key in item.optionList" style="margin-right: 40px">
              <span v-if="item.subjectType == 4">
                <a-rate v-model="key.optionName" disabled/>
              </span>
              <span v-else>{{key.optionName}}</span>
            </span>
              <!--&lt;!&ndash;单选&ndash;&gt;-->
              <!--<a-radio-group v-decorator ="['value' + item.sort,{rules: [{ required: false, message: '请选择'}]}]" :required="false" @change="onChange(index,$event)" v-if="item.subjectType == '单选题'">-->
              <!--<a-radio v-for="int in item.optionList" :value="int.optionName" :key="int.optionId" style="margin-right: 30px">-->
              <!--{{int.optionName}}-->
              <!--</a-radio>-->
              <!--</a-radio-group>-->
              <!--&lt;!&ndash;评分&ndash;&gt;-->
              <!--<a-rate  v-decorator ="['value' + item.sort,{rules: [{ required: false, message: '请选择'}]}]" v-else-if="item.subjectType == '选择星级'"/>-->
              <!--&lt;!&ndash;多选&ndash;&gt;-->
              <!--<a-checkbox-group-->
              <!--v-decorator ="['value' + item.sort,{rules: [{ required: false, message: '请选择'}]}]"-->
              <!--v-else-if="item.subjectType == '多选题'"-->
              <!--@change="handleCheck(index,$event)"-->
              <!--&gt;-->
              <!--<a-checkbox v-for="type in item.optionList" :key="type.optionId" :value="type.optionName">-->
              <!--{{type.optionName}}-->
              <!--</a-checkbox>-->
              <!--</a-checkbox-group>-->
              <!--&lt;!&ndash;下拉框&ndash;&gt;-->
              <!--<a-select  v-decorator ="['value' + item.sort,{rules: [{ required: false, message: '请输入'}]}]" v-else-if="item.subjectType == '下拉框'" @change="handleSelect(index,$event)">-->
              <!--<a-select-option  v-for="type in item.optionList" :key="type.optionName" :value="type.optionName">{{type.optionName}}</a-select-option>-->
              <!--</a-select>-->
              <!--&lt;!&ndash;输入框&ndash;&gt;-->
              <!--<a-input  v-decorator ="['value' + item.sort,{rules: [{ required: false, message: '请输入'}]}]" v-else-if="item.subjectType == '单项填空题'"></a-input>-->
            </div>
          </a-form-item>
          <a-divider dashed/>
        </div>
        <a-button type="primary" style="margin-left: 46%" @click="handleCancel">
          重新核销
        </a-button>
      </a-form>
    </a-modal>
    <cancel-list-model ref="modal" @ok="handleOk"></cancel-list-model>
  </div>
</template>

<script>

  import { getQuestion } from '@/api/order/cancelList'
  import cancelListModel from './cancelListModel'

  export default {
    name: "examineCancelModel",
    components: {
      cancelListModel,
    },
    data(){
      return{
        form: this.$form.createForm(this),
        visible:false,
        data:[],
        record:'',
      }
    },
    created () {

    },
    methods: {
      show(record){
        this.visible = true
        this.form.resetFields()
        this.record = record
        // '010c15ffc06d4a16bae0d5d2d736e862'
        getQuestion(record.orderId).then(res=>{
          // console.log(res)
          this.data = res.data.questionnaireList
        })
      },
      handleCancel(){
        this.$refs.modal.edit(this.record,2)
        this.visible = false
      },
      handleSubmit1(){
        this.visible = false
      },
      handleOk(){
        this.$emit('ok')
      }
    },
  }
</script>

<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 6px 16px;}
</style>